// Cloudinary Configuration for Browser
export const cloudinaryConfig = {
  cloud_name: 'dvggmdp8g',
  api_key: '637475936457725',
  upload_preset: 'cs2_lineups' // You'll need to create this upload preset
};

// Upload function for files using browser-compatible API
export const uploadToCloudinary = async (file: File, customFileName?: string): Promise<string> => {
  return new Promise((resolve, reject) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('upload_preset', cloudinaryConfig.upload_preset);
    
    // Add custom public_id if provided
    if (customFileName) {
      formData.append('public_id', customFileName);
    }

    fetch(`https://api.cloudinary.com/v1_1/${cloudinaryConfig.cloud_name}/image/upload`, {
      method: 'POST',
      body: formData
    })
    .then(response => {
      if (!response.ok) {
        throw new Error(`Upload failed: ${response.status}`);
      }
      return response.json();
    })
    .then(data => {
      if (data.secure_url) {
        resolve(data.secure_url);
      } else {
        reject(new Error('Upload failed: No URL returned'));
      }
    })
    .catch(error => {
      console.error('Cloudinary upload error:', error);
      reject(error);
    });
  });
};

// Generate optimized URL (browser-compatible)
export const getOptimizedUrl = (publicId: string, options: any = {}) => {
  const baseUrl = `https://res.cloudinary.com/${cloudinaryConfig.cloud_name}/image/upload`;
  const params = new URLSearchParams({
    fetch_format: 'auto',
    quality: 'auto',
    ...options
  });
  return `${baseUrl}/${publicId}?${params.toString()}`;
}; 